export const MAX_NAME_LENGTH = 50;
export const MAX_CONTENT_LENGTH = 2200;
export const MAX_HASHTAGS_COUNT = 30;
